import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allSearchSuggestions: [],
  allgames: [],
  allAuctions: [],
  searchnames: [],
  auctionDetail: [],
  bidOnGoing: [],
  homeCrausalHandleData: [],
  footerNewsletterHandleData: [],
  lostData: false,
  searchValue: null,
  categoryValue: null,
  enterKeyVal: false,
  allSellItems: [],
  totalSellItems: 0,
  watchlists: [],
  savesearch: [],
  endingauctions: [],
  totalendings: 0,
  newauctions: [],
  totalnewest: 0,
  comingSoonAuctions: [],
  totalComingSoon: 0,
  reservedauctions: [],
  totalreserved: 0,
  allcategories: [],
  userallbids: [],
  totalallbids: 0,
  gamedetail: [],
  totalsold: 0,
  edititem: null,
  totalcategories: 0,
  allsearchCategories: null,
  editedItem: false,
  gotoSellItem: null,
  resetTime: false,
  completedauctions: [],
  totalcompleted: 0,
  totalClosest: 0,
  allauctionCategories: [],
  featuredauctions: [],
  totalfeatured: 0,
  currentauctions: [],
  totalcurrent: 0,
  savedSearches: [],
  disputes: [],
  disputesTotal: 0,
  addresses: [],
  addressesTotal: 0,
  deliveryStatus: null,
  auctionSubmit: false,
  searchData: [],
  managedBidsList: [],
  managedBidsLoading: false,
  managedBidsError: null,
  managedBidsPagination: {
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    limit: 10,
  },
  managedBidsFilters: {
    showLost: true,
    showWon: true,
    showLive: true,
  },
  wonAuctionsList: [],
  wonAuctionsLoadingState: false,
  wonAuctionsErrorState: null,
  wonAuctionsPagination: {
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    limit: 10,
  },
  listedAuctionsList: [],
  listedAuctionsLoadingState: false,
  listedAuctionsErrorState: null,
  listedAuctionsPagination: {
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    limit: 10,
  },
  orderItem: [],
  totalorders: 0,
  listedAuctionsFilters: {
    showPending: true,
    showLive: true,
    showPast: true,
  },
  itemsListed: [],
  totalitems: 0,
  solditems: [],
  totalsolditem: 0,
  on_auctiondata: [],
  won_bid: [],
  lost_bid: [],
  all_bid: [],
  ongoing_bid: [],
  is_auctiondata: [],
  sellerdetail: [],
  pushNotifications: [],
  allShippingMethods: [],
  trackstatus: [],
  categories: [],
  cartitems: [],
  searchValues: [],
};

const auctionSlice = createSlice({
  name: "gamesSlice",
  initialState,
  reducers: {
    searchValues: (state, action) => {
      state.searchValues = action.payload;
    },
    setAllSearchSuggestions: (state, action) => {
      state.allSearchSuggestions = action.payload;
    },
    setAllAuctionGames: (state, action) => {
      state.allgames = action.payload;
    },
    setAllSellerAuctions: (state, action) => {
      state.allAuctions = action.payload;
    },
    setAllMyAuctions: (state, action) => {
      state.itemsListed = [...action.payload.data];
      state.totalitems = Number(action.payload?.length);
    },
    setMyAuctionDetail: (state, action) => {
      state.auctionDetail = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setCartItems: (state, action) => {
      state.cartitems = action.payload;
    },
    setAllMyOrder: (state, action) => {
      state.orderItem = [...action.payload.data];
      state.totalorders = Number(action.payload?.length);
    },
    setAllMySoldItem: (state, action) => {
      state.soldItem = action.payload;
      state.totalsolditem = Number(action.payload?.length);
    },
    setMyBidOngoing: (state, action) => {
      state.bidOnGoing = action.payload;
    },
    setHandleHomeSlide: (state, action) => {
      state.homeCrausalHandleData = action.payload;
    },
    setHandleFooterNewsletter: (state, action) => {
      state.footerNewsletterHandleData = action.payload;
    },
    setAllShippingMethod: (state, action) => {
      state.allShippingMethods = action.payload;
    },
    setAuctionSearchNames: (state, action) => {
      state.searchnames = action.payload;
    },
    setItemSearchValue: (state, action) => {
      state.searchValue = action.payload;
    },
    setCategorySearchValue: (state, action) => {
      state.categoryValue = action.payload;
    },
    setEnterKeyVal: (state, action) => {
      state.enterKeyVal = action.payload;
    },
    setAllSellItems: (state, action) => {
      state.allSellItems = action.payload.data;
      state.totalSellItems = action.payload.total;
    },
    setAllWatchLists: (state, action) => {
      state.watchlists = action.payload;
      state.savesearch = action.payload.save_search;
    },
    setAuctionSubmited: (state, action) => {
      state.auctionSubmit = action.payload;
    },
    setAllEndingAuctions: (state, action) => {
      state.endingauctions = action.payload.data;
    },
    setSellerDetail: (state, action) => {
      state.sellerdetail = action.payload.data;
    },
    setTrackStatus: (state, action) => {
      state.trackstatus = action.payload.data;
    },
    setAllNewNotifications: (state, action) => {
      state.pushNotifications.unshift(action.payload);
    },
    setAllSearchedCategory: (state, action) => {
      if (action.payload) {
        state.allsearchCategories = action.payload;
      }
    },
    setAllNewAuctions: (state, action) => {
      state.newauctions = action.payload.data;
      state.totalnewest = action.payload.total;
    },
    setAllComingSoonAuctions: (state, action) => {
      state.comingSoonAuctions = action.payload.data;
      state.totalComingSoon = action.payload.total;
    },
    setFetchUserManagedBidsLoading: (state) => {
      state.managedBidsLoading = true;
      state.managedBidsError = null;
    },
    setFetchUserManagedBidsSuccess: (state, action) => {
      state.managedBidsLoading = false;
      state.managedBidsList = action.payload.items || [];
      state.managedBidsPagination = action.payload.pagination;
      state.managedBidsError = null;
    },
    setFetchUserManagedBidsError: (state, action) => {
      state.managedBidsLoading = false;
      state.managedBidsError = action.payload;
      state.managedBidsList = [];
    },
    setManagedBidsFilter: (state, action) => {
      state.managedBidsFilters[action.payload.filterName] =
        action.payload.value;
    },
    resetManagedBidsFilters: (state) => {
      state.managedBidsFilters = {
        showLost: true,
        showWon: true,
        showLive: true,
      };
    },
    wsUpdateMyBidStatusManaged: (state, action) => {
      const updatedItem = action.payload;
      const existingItemIndex = state.managedBidsList.findIndex(
        (item) => item.auctionId === updatedItem.auctionId
      );

      if (existingItemIndex > -1) {
        state.managedBidsList[existingItemIndex] = {
          ...state.managedBidsList[existingItemIndex],
          auctionTitle:
            updatedItem.auctionTitle ||
            state.managedBidsList[existingItemIndex].auctionTitle,
          myHighestBidAmount: updatedItem.myHighestBidAmount,
          overallHighestBidAmount: updatedItem.overallHighestBid,
          status: updatedItem.status,
          endDate: updatedItem.endDate,
        };
      } else {
        state.managedBidsList.unshift({
          auctionId: updatedItem.auctionId,
          auctionTitle: updatedItem.auctionTitle,
          myHighestBidAmount: updatedItem.myHighestBidAmount,
          overallHighestBidAmount: updatedItem.overallHighestBid,
          status: updatedItem.status,
          endDate: updatedItem.endDate,
        });
      }
    },
    wsUserWasOutbidManaged: (state, action) => {
      const outbidUpdate = action.payload;
      const item = state.managedBidsList.find(
        (item) => item.auctionId === outbidUpdate.auctionId
      );
      if (item) {
        item.overallHighestBidAmount = outbidUpdate.overallHighestBid;
        item.status = "outbid";
        item.latest_bid_by = outbidUpdate.outBidById;
        item.endDate = outbidUpdate.endDate;
      }
    },
    wsTrackedAuctionEndedManaged: (state, action) => {
      const endedUpdate = action.payload;
      const item = state.managedBidsList.find(
        (item) => item.auctionId === endedUpdate.auctionId
      );
      if (item) {
        item.status = endedUpdate.status;
        item.overallHighestBid =
          endedUpdate.winningBidAmount || item.overallHighestBid;
      }
    },
    setAllReservedAuctions: (state, action) => {
      state.reservedauctions = action.payload.data;
      state.totalreserved = action.payload.total;
    },
    setAllCategories: (state, action) => {
      state.allcategories = action.payload.data.filter(
        (item) => item?.is_feature === true
      );
      state.allauctionCategories = [
        ...state.allauctionCategories,
        ...(action.payload.data || []),
      ];
      state.totalcategories = action.payload.total;
    },
    setGameDetail: (state, action) => {
      state.gamedetail = action.payload;
    },
    setAllUserBids: (state, action) => {
      state.userallbids = action.payload.data;
      state.totalallbids = action.payload.total;
    },
    setAllSoldItems: (state, action) => {
      state.solditems = action.payload.data;
      state.totalsold = action.payload.total;
    },
    setEditItemDetail: (state, action) => {
      state.edititem = action.payload;
    },
    setEditItemValue: (state, action) => {
      state.editedItem = action.payload;
    },
    setGoToSellItem: (state, action) => {
      state.gotoSellItem = action.payload;
    },
    setResetTime: (state, action) => {
      state.resetTime = action.payload;
    },
    setAllCompletedAuctions: (state, action) => {
      state.completedauctions = action.payload.data;
      state.totalcompleted = action.payload.total;
    },
    setTotalEnding: (state, action) => {
      state.totalendings = action.payload;
    },
    setClosestTotal: (state, action) => {
      state.totalClosest = action.payload;
    },
    setAllFeaturedAuctions: (state, action) => {
      state.featuredauctions = action.payload.data;
      state.totalfeatured = action.payload.total;
    },
    setLostData: (state, action) => {
      state.lostData = action.payload;
    },
    setCurrentBidAuctions: (state, action) => {
      state.currentauctions = action.payload.data;
      state.totalcurrent = action.payload.total;
    },
    setUserSavedSearches: (state, action) => {
      state.savedSearches = action.payload;
    },
    setOnAuction: (state, action) => {
      state.on_auctiondata = action.payload;
    },
    setUserDisputes: (state, action) => {
      state.disputes = action.payload.data;
      state.disputesTotal = action.payload.total;
    },
    setUserShippingAddresses: (state, action) => {
      state.addresses = action.payload.list;
      state.addressesTotal = action.payload?.total || 0;
    },
    setUserDeliveryStatus: (state, action) => {
      state.deliveryStatus = action.payload;
    },
    setSearchData: (state, action) => {
      state.searchData = action.payload;
    },
    setWonBidManagement: (state, action) => {
      state.won_bid = action.payload;
    },
    setLostBidManagement: (state, action) => {
      state.lost_bid = action.payload;
    },
    setAllBidManagement: (state, action) => {
      state.all_bid = action.payload;
    },
    setOngoingBidManagement: (state, action) => {
      state.ongoing_bid = action.payload;
    },
    setIsAuction: (state, action) => {
      state.is_auctiondata = action.payload;
    },
    setFetchUserWonAuctionsLoading: (state) => {
      state.wonAuctionsLoadingState = true;
      state.wonAuctionsErrorState = null;
    },
    setFetchUserWonAuctionsSuccess: (state, action) => {
      state.wonAuctionsLoadingState = false;
      state.wonAuctionsList = action.payload.items || [];
      state.wonAuctionsPagination = action.payload.pagination;
      state.wonAuctionsErrorState = null;
    },
    setFetchUserWonAuctionsError: (state, action) => {
      state.wonAuctionsLoadingState = false;
      state.wonAuctionsErrorState = action.payload;
      state.wonAuctions = [];
      state.wonAuctionsPagination = {
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
        limit: state.wonAuctionsPagination.limit,
      };
    },
    setFetchUserListedAuctionsLoading: (state) => {
      state.listedAuctionsLoadingState = true;
      state.listedAuctionsErrorState = null;
    },
    setFetchUserListedAuctionsSuccess: (state, action) => {
      state.listedAuctionsLoadingState = false;
      state.listedAuctionsList = action.payload.items || [];
      state.listedAuctionsPagination = action.payload.pagination;
      state.listedAuctionsErrorState = null;
    },
    deleteAuctionSuccess: (state, action) => {
      const deletedItemId = action.payload;
      state.listedAuctionsList = state.listedAuctionsList.filter(
        (item) => item._id !== deletedItemId
      );
      state.newauctions = state.newauctions.filter(
        (item) => item._id !== deletedItemId
      );
      state.endingauctions = state.endingauctions.filter(
        (item) => item._id !== deletedItemId
      );
      state.comingSoonAuctions = state.comingSoonAuctions.filter(
        (item) => item._id !== deletedItemId
      );
      state.featuredauctions = state.featuredauctions.filter(
        (item) => item._id !== deletedItemId
      );
    },
    setFetchUserListedAuctionsError: (state, action) => {
      state.listedAuctionsLoadingState = false;
      state.listedAuctionsErrorState = action.payload;
      state.listedAuctions = [];
      state.listedAuctionsPagination = {
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
        limit: state.listedAuctionsPagination.limit,
      };
    },
    setListedAuctionsFilter: (state, action) => {
      state.listedAuctionsFilters[action.payload.filterName] =
        action.payload.value;
    },
    resetListedAuctionsFilters: (state) => {
      state.listedAuctionsFilters = {
        showPending: true,
        showLive: true,
        showPast: true,
      };
    },
    updateListedAuctionItem: (state, action) => {
      const updatedItem = action.payload;
      const item = state.listedAuctionsList.find(
        (item) => item._id === updatedItem._id
      );
      if (item) {
        Object.assign(item, updatedItem);
      }
    },
    updateSoldItem: (state, action) => {
      const updatedItem = action.payload;
      const item = state.solditems.find((item) => item._id === updatedItem._id);
      if (item) {
        Object.assign(item, updatedItem);
      }
    },
    updateManagedBidItem: (state, action) => {
      const updatedItem = action.payload;
      const item = state.managedBidsList.find(
        (item) => item.auctionId === updatedItem._id
      );
      if (item) {
        item.rated_by = updatedItem.rated_by;
        item.address = updatedItem.address;
        item.status = updatedItem.auctionProcessStatus;
      }
    },
    updateWonAuctionItem: (state, action) => {
      const updatedItem = action.payload;
      const item = state.wonAuctionsList.find(
        (item) => item.auctionId === updatedItem._id
      );
      if (item) {
        item.rated_by = updatedItem.rated_by;
        item.address = updatedItem.address;
        item.status = updatedItem.auctionProcessStatus;
      }
    },
    setAuctionViews: (state, action) => {
      // Add implementation if needed
    },
  },
});

export const {
  searchValues,
  setAllSearchSuggestions,
  setAllAuctionGames,
  setAllSellerAuctions,
  setAllMyAuctions,
  setMyAuctionDetail,
  setCategories,
  setCartItems,
  setAllMyOrder,
  setAllMySoldItem,
  setMyBidOngoing,
  setHandleHomeSlide,
  setHandleFooterNewsletter,
  setAllShippingMethod,
  setAuctionSearchNames,
  setItemSearchValue,
  setCategorySearchValue,
  setEnterKeyVal,
  setAllSellItems,
  setAllWatchLists,
  setAuctionSubmited,
  setAllEndingAuctions,
  setSellerDetail,
  setTrackStatus,
  setAllNewNotifications,
  setAllSearchedCategory,
  setAllNewAuctions,
  setAllComingSoonAuctions,
  setFetchUserManagedBidsLoading,
  setFetchUserManagedBidsSuccess,
  setFetchUserManagedBidsError,
  setManagedBidsFilter,
  resetManagedBidsFilters,
  wsUpdateMyBidStatusManaged,
  wsUserWasOutbidManaged,
  wsTrackedAuctionEndedManaged,
  setAllReservedAuctions,
  setAllCategories,
  setGameDetail,
  setAllUserBids,
  setAllSoldItems,
  setEditItemDetail,
  setEditItemValue,
  setGoToSellItem,
  setResetTime,
  setAllCompletedAuctions,
  setTotalEnding,
  setClosestTotal,
  setAllFeaturedAuctions,
  setLostData,
  setCurrentBidAuctions,
  setUserSavedSearches,
  setOnAuction,
  setUserDisputes,
  setUserShippingAddresses,
  setUserDeliveryStatus,
  setSearchData,
  setWonBidManagement,
  setLostBidManagement,
  setAllBidManagement,
  setOngoingBidManagement,
  setIsAuction,
  setFetchUserWonAuctionsLoading,
  setFetchUserWonAuctionsSuccess,
  setFetchUserWonAuctionsError,
  setFetchUserListedAuctionsLoading,
  setFetchUserListedAuctionsSuccess,
  deleteAuctionSuccess,
  setFetchUserListedAuctionsError,
  setListedAuctionsFilter,
  resetListedAuctionsFilters,
  updateListedAuctionItem,
  updateSoldItem,
  updateManagedBidItem,
  updateWonAuctionItem,
  setAuctionViews,
} = auctionSlice.actions;
export default auctionSlice.reducer;
